import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HammerModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { SettingsComponent } from 'app/layout/common/settings/settings.component';
import { SharedModule } from 'app/shared/shared.module';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
    declarations: [
        SettingsComponent
    ],
    imports     : [
        SharedModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
        FuseDrawerModule,
        MatButtonModule,
        ImageCropperModule,
        HammerModule 
    ],
    exports     : [
        SettingsComponent
    ]
})
export class SettingsModule {}